import React, {forwardRef} from 'react';
import {HobbiesStyle, TextStyle} from '../assets/css/Styles';
import {Container, Row, Col} from 'react-bootstrap';
import EachHobby from './EachHobby';
import PlayFootballImage from '../assets/images/hobbyImages/playFootball2.png';
import WatchTVImage from '../assets/images/hobbyImages/watchTV.png';
import SwimmingImage from '../assets/images/hobbyImages/swimming1.png';
import PlayGame from '../assets/images/hobbyImages/playGame1.png';
import MainTitle from './MainTitle';

/**
 *
 * @return {Component} the hobbies component
 */
export const Hobbies = forwardRef(({}, ref) => {
  return (
    <Container ref={ref} style={HobbiesStyle.hobbiesContainer}>
      <MainTitle title='HOBBIES' />
      <Col style={HobbiesStyle.subTitleDiv}>
        <span style={TextStyle.subTitleTxt1}>
            When I am not coding, you can find me...
        </span>
      </Col>
      <Row>
        <Col style={HobbiesStyle.eachHobbyCol}>
          <EachHobby
            hobbyImageSrc={PlayGame}
            hobbyName='Playing video games'
          />
        </Col>
        <Col>
          <EachHobby
            hobbyImageSrc={PlayFootballImage}
            hobbyName='Playing football'
          />
        </Col>
        <Col>
          <EachHobby
            hobbyImageSrc={WatchTVImage}
            hobbyName='Watching movies/football'
          />
        </Col>
        <Col>
          <EachHobby
            hobbyImageSrc={SwimmingImage}
            hobbyName='Swimming'
          />
        </Col>
      </Row>
    </Container>
  );
});
